export var valuesGameTypeEnum = ["Undefined", "Multiplayer", "Singleplayer"];
/*

*/ 
//# sourceMappingURL=GameTypeEnum.js.map